export type DexBuySellExternalStopEvent = {
  side: 'buy' | 'sell';
  tx_hash: string;
  block_number: number;
  transaction_index: number;
  log_index: number;
  stopped_at: string;
};

export const readDexBuySellExternalStopEnabled = (options: {
  stop_on_external_same_side?: boolean;
}) => options.stop_on_external_same_side === true;

export const formatDexBuySellExternalStopReason = (event: DexBuySellExternalStopEvent) => {
  const hash = event.tx_hash;
  const shortHash = hash.length > 15 ? `${hash.slice(0, 8)}…${hash.slice(-6)}` : hash;

  return `Stopped after external ${event.side} ${shortHash} at block ${event.block_number}`;
};
